module.exports = __webpack_public_path__ + "img/wlg-2024.8e7b4dd4.jpg";